import actionTypes from './actionTypes';

export const editQuestion = (payload: any) => ({
    type: actionTypes.EDIT_QUESTION,
    payload
});

export const setAddNewQuestion = (payload: any) => ({
    type: actionTypes.SET_ADD_NEW_QUESTION,
    payload
});

export const setLogicQuestion = (payload: any) => ({
    type: actionTypes.SET_LOGIC_QUESTION,
    payload
});

export const clearQuestionStatus = (payload: any) => ({
    type: actionTypes.CLEAR_QUESTION_STATUS,
    payload
});
